import { render } from "./vmsLogin.vue?vue&type=template&id=a67c8488"
import script from "./vmsLogin.vue?vue&type=script&lang=js"
export * from "./vmsLogin.vue?vue&type=script&lang=js"

import "./vmsLogin.vue?vue&type=style&index=0&id=a67c8488&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__